export default "__VITE_ASSET___WTshPbC__"